import { Unit_instancev9v8hjid95df as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { FileUploadAwareJsonWriter1mx337tg0y9oj as FileUploadAwareJsonWriter } from '../json/internal/FileUploadAwareJsonWriter.mjs';
import { LinkedHashMap1zhqxkxv3xnkl as LinkedHashMap } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/LinkedHashMap.mjs';
import { Buffer3384y49aj0pxr as Buffer } from '../../../../../../okio-parent-okio/okio/Buffer.mjs';
import { BufferedSinkJsonWriter1xl4ankftitqq as BufferedSinkJsonWriter } from '../json/BufferedSinkJsonWriter.mjs';
import { IllegalStateExceptionkoljg5n0nrlr as IllegalStateException } from '../../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { toString1pkumu07cwy4m as toString } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { charSequenceLength3278n89t01tmv as charSequenceLength } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/charSequenceJs.mjs';
import {
  fromInt2ii0rejb1w62w as fromInt,
  add2suhfggl4zvkk as add,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/internal/longAsBigInt/longAsBigInt.mjs';
import {
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { StringBuildermazzzhj6kkai as StringBuilder } from '../../../../../../kotlin-kotlin-stdlib/kotlin/text/StringBuilderJs.mjs';
import { contains3ue2qo8xhmpf1 as contains } from '../../../../../../kotlin-kotlin-stdlib/kotlin/text/Strings.mjs';
import { _Char___init__impl__6a9atx2gndcvjvc5pke as _Char___init__impl__6a9atx } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Char.mjs';
import { urlEncoded5v8jd8by0u4 as urlEncode } from './internal/UrlEncode.mjs';
import { Key_getInstance4887rkxhu93r as Key_getInstance } from '../CustomScalarAdapters.mjs';
import { MapJsonWriter4jz7ym6vbwk4 as MapJsonWriter } from '../json/MapJsonWriter.mjs';
import {
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
  noWhenBranchMatchedException2a6r7ubxgky5j as noWhenBranchMatchedException,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { KtMap140uvy3s5zad8 as KtMap } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/Collections.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import {
  HttpHeader1d7ldebjomr00 as HttpHeader,
  HttpMethod_Post_getInstance1acsve6b42vet as HttpMethod_Post_getInstance,
  HttpMethod_Get_getInstance139ackgavp29i as HttpMethod_Get_getInstance,
  Builder2ocxamygt14i4 as Builder,
} from './Http.mjs';
import { Subscription2xxf73xmsvgi0 as Subscription } from '../Subscription.mjs';
import { startsWith26w8qjqapeeq6 as startsWith } from '../../../../../../kotlin-kotlin-stdlib/kotlin/text/stringsCode.mjs';
import { collectionSizeOrDefault36dulx8yinfqm as collectionSizeOrDefault } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/Iterables.mjs';
import {
  checkIndexOverflow3frtmheghr0th as checkIndexOverflow,
  listOfvhqybd2zx248 as listOf,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/collectionJs.mjs';
import { to2cs3ny02qtbcb as to } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Tuples.mjs';
import { toMap1vec9topfei08 as toMap } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/Maps.mjs';
import { writeAny16i13331zbqlc as writeAny } from '../json/JsonWriters.mjs';
import { uuid4al7pp0fcb8o5 as uuid4 } from '../../../../../../uuid/com/benasher44/uuid/uuid.mjs';
import {
  blackholeSink1e341pykjnhp5 as blackholeSink,
  buffer10rjf0ze3bqic as buffer,
} from '../../../../../../okio-parent-okio/okio/Okio.mjs';
import { lazy2hsh8ze7j6ikd as lazy } from '../../../../../../kotlin-kotlin-stdlib/kotlin/kotlin.mjs';
import { KProperty1ca4yb4wlo496 as KProperty1 } from '../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import { getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function buildGetUrl($this, serverUrl, operation, customScalarAdapters, sendApqExtensions, sendDocument, sendEnhancedClientAwarenessExtensions) {
  return $this.g48(serverUrl, composeGetParams($this, operation, customScalarAdapters, sendApqExtensions, sendDocument, sendEnhancedClientAwarenessExtensions));
}
function composePostParams($this, writer, operation, customScalarAdapters, query, extensionsWriter) {
  var uploads = {_v: null};
  // Inline function 'com.apollographql.apollo.api.json.writeObject' call
  writer.f41();
  writer.h48('operationName');
  writer.r41(operation.operationName());
  writer.h48('variables');
  var uploadAwareWriter = new (FileUploadAwareJsonWriter())(writer);
  // Inline function 'com.apollographql.apollo.api.json.writeObject' call
  uploadAwareWriter.f41();
  operation.f47(uploadAwareWriter, customScalarAdapters, false);
  uploadAwareWriter.g41();
  uploads._v = uploadAwareWriter.k48();
  if (!(query == null)) {
    writer.h48('query');
    writer.r41(query);
  }
  extensionsWriter(writer);
  writer.g41();
  return uploads._v;
}
function composePostParams_0($this, writer, operation, customScalarAdapters, sendApqExtensions, sendEnhancedClientAwarenessExtensions, query) {
  return composePostParams($this, writer, operation, customScalarAdapters, query, extensionsWriter($this, operation.operationId(), sendApqExtensions, sendEnhancedClientAwarenessExtensions));
}
function extensionsWriter($this, apqId, sendApqExtensions, sendEnhancedClientAwarenessExtensions) {
  if (!sendApqExtensions && !sendEnhancedClientAwarenessExtensions) {
    return DefaultHttpRequestComposer$Companion$extensionsWriter$lambda;
  }
  return (_this__u8e3s4) => {
    _this__u8e3s4.h48('extensions');
    // Inline function 'com.apollographql.apollo.api.json.writeObject' call
    _this__u8e3s4.f41();
    if (sendApqExtensions) {
      _this__u8e3s4.h48('persistedQuery');
      // Inline function 'com.apollographql.apollo.api.json.writeObject' call
      _this__u8e3s4.f41();
      _this__u8e3s4.h48('version').t41(1);
      _this__u8e3s4.h48('sha256Hash').r41(apqId);
      _this__u8e3s4.g41();
    }
    if (sendEnhancedClientAwarenessExtensions) {
      _this__u8e3s4.h48('clientLibrary');
      // Inline function 'com.apollographql.apollo.api.json.writeObject' call
      _this__u8e3s4.f41();
      _this__u8e3s4.h48('name').r41('apollo-kotlin');
      _this__u8e3s4.h48('version').r41('4.4.2');
      _this__u8e3s4.g41();
    }
    _this__u8e3s4.g41();
    return Unit_instance;
  };
}
function composeGetParams($this, operation, customScalarAdapters, autoPersistQueries, sendDocument, sendEnhancedClientAwareness) {
  // Inline function 'kotlin.collections.mutableMapOf' call
  var queryParams = LinkedHashMap().bc();
  queryParams.x4('operationName', operation.operationName());
  // Inline function 'com.apollographql.apollo.api.json.buildJsonString' call
  var buffer = new (Buffer())();
  var $this$buildJsonString = new (BufferedSinkJsonWriter())(buffer, null);
  var uploadAwareWriter = new (FileUploadAwareJsonWriter())($this$buildJsonString);
  // Inline function 'com.apollographql.apollo.api.json.writeObject' call
  uploadAwareWriter.f41();
  operation.f47(uploadAwareWriter, customScalarAdapters, false);
  uploadAwareWriter.g41();
  // Inline function 'kotlin.check' call
  if (!uploadAwareWriter.k48().n1()) {
    var message = 'FileUpload and Http GET are not supported at the same time';
    throw IllegalStateException().o(toString(message));
  }
  var variables = buffer.t3y();
  queryParams.x4('variables', variables);
  if (sendDocument) {
    queryParams.x4('query', operation.l48());
  }
  // Inline function 'com.apollographql.apollo.api.json.buildJsonString' call
  var buffer_0 = new (Buffer())();
  // Inline function 'com.apollographql.apollo.api.json.writeObject' call
  var this_0 = new (BufferedSinkJsonWriter())(buffer_0, null);
  this_0.f41();
  if (autoPersistQueries) {
    this_0.h48('persistedQuery');
    // Inline function 'com.apollographql.apollo.api.json.writeObject' call
    this_0.f41();
    this_0.h48('version').t41(1);
    this_0.h48('sha256Hash').r41(operation.operationId());
    this_0.g41();
  }
  if (sendEnhancedClientAwareness) {
    this_0.h48('clientLibrary');
    // Inline function 'com.apollographql.apollo.api.json.writeObject' call
    this_0.f41();
    this_0.h48('name').r41('apollo-kotlin');
    this_0.h48('version').r41('4.4.2');
    this_0.g41();
  }
  this_0.g41();
  var extensions = buffer_0.t3y();
  // Inline function 'kotlin.text.isEmpty' call
  if (!(charSequenceLength(extensions) === 0)) {
    queryParams.x4('extensions', extensions);
  }
  return queryParams;
}
function DefaultHttpRequestComposer$Companion$extensionsWriter$lambda(_this__u8e3s4) {
  return Unit_instance;
}
var DefaultHttpRequestComposer$Companion$buildPostBody$1Class;
function DefaultHttpRequestComposer$Companion$buildPostBody$1() {
  if (DefaultHttpRequestComposer$Companion$buildPostBody$1Class === VOID) {
    class $ {
      constructor($operationByteString) {
        this.o48_1 = $operationByteString;
        this.m48_1 = 'application/json';
        this.n48_1 = fromInt($operationByteString.q2());
      }
      w47() {
        return this.m48_1;
      }
      x47() {
        return this.n48_1;
      }
      z47(bufferedSink) {
        bufferedSink.b3z(this.o48_1);
      }
    }
    initMetadataForClass($);
    DefaultHttpRequestComposer$Companion$buildPostBody$1Class = $;
  }
  return DefaultHttpRequestComposer$Companion$buildPostBody$1Class;
}
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      constructor() {
        this.a48_1 = 'X-APOLLO-OPERATION-ID';
        this.b48_1 = 'X-APOLLO-OPERATION-NAME';
        this.c48_1 = 'Apollo-Require-Preflight';
        this.d48_1 = 'Accept';
        this.e48_1 = 'multipart/mixed;deferSpec=20220824, application/graphql-response+json, application/json';
        this.f48_1 = 'multipart/mixed;subscriptionSpec=1.0, application/graphql-response+json, application/json';
      }
      g48(_this__u8e3s4, parameters) {
        // Inline function 'kotlin.text.buildString' call
        // Inline function 'kotlin.apply' call
        var this_0 = StringBuilder().l1();
        this_0.m1(_this__u8e3s4);
        var hasQuestionMark = contains(_this__u8e3s4, '?');
        // Inline function 'kotlin.collections.forEach' call
        var _iterator__ex2g4s = parameters.l3().p1();
        while (_iterator__ex2g4s.q1()) {
          var element = _iterator__ex2g4s.r1();
          if (hasQuestionMark) {
            this_0.o1(_Char___init__impl__6a9atx(38));
          } else {
            hasQuestionMark = true;
            this_0.o1(_Char___init__impl__6a9atx(63));
          }
          this_0.m1(urlEncode(element.m3()));
          this_0.o1(_Char___init__impl__6a9atx(61));
          this_0.m1(urlEncode(element.n3()));
        }
        return this_0.toString();
      }
      p48(operation, customScalarAdapters, query, extensionsWriter) {
        var uploads = {_v: null};
        // Inline function 'com.apollographql.apollo.api.json.buildJsonByteString' call
        var buffer = new (Buffer())();
        var $this$buildJsonByteString = new (BufferedSinkJsonWriter())(buffer, null);
        uploads._v = composePostParams(Companion_instance, $this$buildJsonByteString, operation, customScalarAdapters, query, extensionsWriter);
        var operationByteString = buffer.p3y();
        var tmp;
        if (uploads._v.n1()) {
          tmp = new (DefaultHttpRequestComposer$Companion$buildPostBody$1())(operationByteString);
        } else {
          tmp = new (UploadsHttpBody())(uploads._v, operationByteString);
        }
        return tmp;
      }
      q48(apolloRequest) {
        var operation = apolloRequest.i43_1;
        var tmp0_elvis_lhs = apolloRequest.n43_1;
        var sendApqExtensions = tmp0_elvis_lhs == null ? false : tmp0_elvis_lhs;
        var sendEnhancedClientAwarenessExtensions = apolloRequest.u43_1;
        var tmp1_elvis_lhs = apolloRequest.o43_1;
        var sendDocument = tmp1_elvis_lhs == null ? true : tmp1_elvis_lhs;
        var tmp2_elvis_lhs = apolloRequest.k43_1.r46(Key_getInstance());
        var customScalarAdapters = tmp2_elvis_lhs == null ? Key_getInstance().a46_1 : tmp2_elvis_lhs;
        var query = sendDocument ? operation.l48() : null;
        // Inline function 'com.apollographql.apollo.api.json.buildJsonMap' call
        var writer = new (MapJsonWriter())();
        composePostParams_0(Companion_instance, writer, operation, customScalarAdapters, sendApqExtensions, sendEnhancedClientAwarenessExtensions, query);
        var tmp = writer.i41();
        return (!(tmp == null) ? isInterface(tmp, KtMap()) : false) ? tmp : THROW_CCE();
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance() {
  return Companion_instance;
}
var DefaultHttpRequestComposerClass;
function DefaultHttpRequestComposer() {
  if (DefaultHttpRequestComposerClass === VOID) {
    class $ {
      constructor(serverUrl) {
        this.r48_1 = serverUrl;
      }
      s48(apolloRequest) {
        var operation = apolloRequest.i43_1;
        var tmp0_elvis_lhs = apolloRequest.k43_1.r46(Key_getInstance());
        var customScalarAdapters = tmp0_elvis_lhs == null ? Key_getInstance().a46_1 : tmp0_elvis_lhs;
        // Inline function 'kotlin.collections.mutableListOf' call
        // Inline function 'kotlin.apply' call
        var this_0 = ArrayList().p2();
        var tmp = apolloRequest.i43_1;
        if (isInterface(tmp, Subscription())) {
          this_0.i2(new (HttpHeader())(Companion_instance.d48_1, Companion_instance.f48_1));
        } else {
          this_0.i2(new (HttpHeader())(Companion_instance.d48_1, Companion_instance.e48_1));
        }
        if (!(apolloRequest.m43_1 == null)) {
          this_0.u2(apolloRequest.m43_1);
        }
        var requestHeaders = this_0;
        var tmp1_elvis_lhs = apolloRequest.n43_1;
        var sendApqExtensions = tmp1_elvis_lhs == null ? false : tmp1_elvis_lhs;
        var tmp2_elvis_lhs = apolloRequest.o43_1;
        var sendDocument = tmp2_elvis_lhs == null ? true : tmp2_elvis_lhs;
        var sendEnhancedClientAwarenessExtensions = apolloRequest.u43_1;
        var tmp3_elvis_lhs = apolloRequest.l43_1;
        var tmp_0;
        switch ((tmp3_elvis_lhs == null ? HttpMethod_Post_getInstance() : tmp3_elvis_lhs).w1_1) {
          case 0:
            tmp_0 = (new (Builder())(HttpMethod_Get_getInstance(), buildGetUrl(Companion_instance, this.r48_1, operation, customScalarAdapters, sendApqExtensions, sendDocument, sendEnhancedClientAwarenessExtensions))).y48(Companion_instance.c48_1, 'true');
            break;
          case 1:
            var query = sendDocument ? operation.l48() : null;
            var body = Companion_instance.p48(operation, customScalarAdapters, query, extensionsWriter(Companion_instance, operation.operationId(), sendApqExtensions, sendEnhancedClientAwarenessExtensions));
            // Inline function 'kotlin.let' call

            var it = (new (Builder())(HttpMethod_Post_getInstance(), this.r48_1)).z48(body);
            var tmp_1;
            if (startsWith(body.w47(), 'multipart/form-data')) {
              tmp_1 = it.y48(Companion_instance.c48_1, 'true');
            } else {
              tmp_1 = it;
            }

            tmp_0 = tmp_1;
            break;
          default:
            noWhenBranchMatchedException();
            break;
        }
        var httpRequestBuilder = tmp_0;
        return httpRequestBuilder.a49(requestHeaders).h44(apolloRequest.k43_1).p37();
      }
    }
    initMetadataForClass($, 'DefaultHttpRequestComposer');
    DefaultHttpRequestComposerClass = $;
  }
  return DefaultHttpRequestComposerClass;
}
function buildUploadMap($this, uploads) {
  // Inline function 'com.apollographql.apollo.api.json.buildJsonByteString' call
  var buffer = new (Buffer())();
  var $this$buildJsonByteString = new (BufferedSinkJsonWriter())(buffer, null);
  // Inline function 'kotlin.collections.mapIndexed' call
  var this_0 = uploads.l3();
  // Inline function 'kotlin.collections.mapIndexedTo' call
  var destination = ArrayList().h2(collectionSizeOrDefault(this_0, 10));
  var index = 0;
  var _iterator__ex2g4s = this_0.p1();
  while (_iterator__ex2g4s.q1()) {
    var item = _iterator__ex2g4s.r1();
    var _unary__edvuaz = index;
    index = _unary__edvuaz + 1 | 0;
    var index_0 = checkIndexOverflow(_unary__edvuaz);
    var tmp$ret$4 = to(index_0.toString(), listOf(item.m3()));
    destination.i2(tmp$ret$4);
  }
  writeAny($this$buildJsonByteString, toMap(destination));
  return buffer.p3y();
}
function writeBoundaries($this, $receiver, writeUploadContents) {
  $receiver.d3z('--' + $this.d49_1 + '\r\n');
  $receiver.d3z('Content-Disposition: form-data; name="operations"\r\n');
  $receiver.d3z('Content-Type: application/json\r\n');
  $receiver.d3z('Content-Length: ' + $this.c49_1.q2() + '\r\n');
  $receiver.d3z('\r\n');
  $receiver.b3z($this.c49_1);
  var uploadsMap = buildUploadMap($this, $this.b49_1);
  $receiver.d3z('\r\n--' + $this.d49_1 + '\r\n');
  $receiver.d3z('Content-Disposition: form-data; name="map"\r\n');
  $receiver.d3z('Content-Type: application/json\r\n');
  $receiver.d3z('Content-Length: ' + uploadsMap.q2() + '\r\n');
  $receiver.d3z('\r\n');
  $receiver.b3z(uploadsMap);
  // Inline function 'kotlin.collections.forEachIndexed' call
  var index = 0;
  var _iterator__ex2g4s = $this.b49_1.w4().p1();
  while (_iterator__ex2g4s.q1()) {
    var item = _iterator__ex2g4s.r1();
    var _unary__edvuaz = index;
    index = _unary__edvuaz + 1 | 0;
    var index_0 = checkIndexOverflow(_unary__edvuaz);
    $receiver.d3z('\r\n--' + $this.d49_1 + '\r\n');
    $receiver.d3z('Content-Disposition: form-data; name="' + index_0 + '"');
    if (!(item.y47() == null)) {
      $receiver.d3z('; filename="' + item.y47() + '"');
    }
    $receiver.d3z('\r\n');
    $receiver.d3z('Content-Type: ' + item.w47() + '\r\n');
    var contentLength = item.x47();
    if (!(contentLength === -1n)) {
      $receiver.d3z('Content-Length: ' + contentLength.toString() + '\r\n');
    }
    $receiver.d3z('\r\n');
    if (writeUploadContents) {
      item.z47($receiver);
    }
  }
  $receiver.d3z('\r\n--' + $this.d49_1 + '--\r\n');
}
function UploadsHttpBody$_get_contentLength_$ref_e5o4rd() {
  return (p0) => p0.x47();
}
var UploadsHttpBodyClass;
function UploadsHttpBody() {
  if (UploadsHttpBodyClass === VOID) {
    class $ {
      constructor(uploads, operationByteString) {
        this.b49_1 = uploads;
        this.c49_1 = operationByteString;
        this.d49_1 = uuid4().toString();
        this.e49_1 = 'multipart/form-data; boundary=' + this.d49_1;
        var tmp = this;
        tmp.f49_1 = lazy(() => {
          var countingSink = new (CountingSink())(blackholeSink());
          var bufferedCountingSink = buffer(countingSink);
          writeBoundaries(this, bufferedCountingSink, false);
          bufferedCountingSink.lc();
          var tmp = countingSink.h49_1;
          // Inline function 'kotlin.collections.sumOf' call
          var sum = 0n;
          var _iterator__ex2g4s = this.b49_1.w4().p1();
          while (_iterator__ex2g4s.q1()) {
            var element = _iterator__ex2g4s.r1();
            var tmp_0 = sum;
            var tmp$ret$1 = element.x47();
            sum = add(tmp_0, tmp$ret$1);
          }
          var tmp$ret$0 = sum;
          var result = add(tmp, tmp$ret$0);
          return result;
        });
      }
      w47() {
        return this.e49_1;
      }
      x47() {
        var tmp0 = this.f49_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('contentLength', 1, tmp, UploadsHttpBody$_get_contentLength_$ref_e5o4rd(), null);
        return tmp0.n3();
      }
      z47(bufferedSink) {
        writeBoundaries(this, bufferedSink, true);
      }
    }
    initMetadataForClass($, 'UploadsHttpBody');
    UploadsHttpBodyClass = $;
  }
  return UploadsHttpBodyClass;
}
var CountingSinkClass;
function CountingSink() {
  if (CountingSinkClass === VOID) {
    class $ {
      constructor(delegate) {
        this.g49_1 = delegate;
        this.h49_1 = 0n;
      }
      l3v(source, byteCount) {
        this.g49_1.l3v(source, byteCount);
        this.h49_1 = add(this.h49_1, byteCount);
      }
      l6() {
        this.g49_1.l6();
      }
      lc() {
        this.g49_1.lc();
      }
    }
    initMetadataForClass($, 'CountingSink');
    CountingSinkClass = $;
  }
  return CountingSinkClass;
}
//region block: init
Companion_instance = new (Companion())();
//endregion
//region block: exports
export {
  DefaultHttpRequestComposer as DefaultHttpRequestComposer3cbqxfvy17yg2,
  Companion_instance as Companion_instancegdssxde1x86b,
};
//endregion

//# sourceMappingURL=DefaultHttpRequestComposer.mjs.map
